import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./styles.scss";
import { Bin, FileUpload } from "../../assets/images";
import { ChevronUp, DocumentIcon } from "../../assets/svgs";
import useApp from "../../hooks/useApp";

const UploadCard = ({ onFileUpload }) => {
  const {
    handleFileSelect,
    isRTL,
    handleSetFileUploadProgress,
    fileUploadProgress,
    handleSetFileUploadDetails,
    fileUploadDetails,
  } = useApp();
  const location = useLocation();
  const { pathname } = location;
  const routeName = pathname.split("/")[1];
  const { t } = useTranslation();

  const handleFileUpload = (e) => {
    const file = e.target.files?.[0];
    const MAX_FILE_SIZE = 25 * 1024 * 1024; // 25 MB in bytes

    if (!file) return;

    if (!["image/png", "image/jpeg", "application/pdf"].includes(file.type)) {
      return;
    }
    if (file.size > MAX_FILE_SIZE) {
      return;
    }

    handleSetFileUploadDetails({
      name: file.name,
      size: `${(file.size / 1024).toFixed(0)} ${t(
        `${routeName}.${"file_size_kb"}`
      )}`,
    });
    handleSetFileUploadProgress(1);

    const reader = new FileReader();
    reader.onload = () => {
      const base64String = reader.result;
      if (onFileUpload) {
        handleSetFileUploadDetails({
          name: file.name,
          size: `${(file.size / 1024).toFixed(0)} ${t(
            `${routeName}.${"file_size_kb"}`
          )}`,
          file,
          base64: base64String,
          type: file.type,
        });
        onFileUpload({
          file,
          base64: base64String,
          type: file.type,
        });
      }
    };
    reader.readAsDataURL(file);
  };

  const reset = () => {
    handleSetFileUploadProgress(0);
    handleSetFileUploadDetails({});
    handleFileSelect(null);
  };
  return (
    <div className="upload-card">
      {fileUploadProgress === 0 && (
        <div className="upload-prompt">
          <input
            type="file"
            id="upload-input"
            accept="image/*,application/pdf"
            hidden
            onChange={handleFileUpload}
          />
          <div className="upload-row-header">
            <div className="upload-header-title">
              {t(`${routeName}.${"upload_your_request"}`)}
            </div>
            <img
              src={ChevronUp}
              alt="upload-icon"
              className="upload-icon-small"
            />
          </div>
          <label className="description">
            {t(`${routeName}.${"boost_approval_rate"}`)}
          </label>

          <div className="upload-row">
            <img src={FileUpload} alt="Upload" className="upload-icon" />
            <div className="upload-title">
              {t(`${routeName}.${"upload_credit_report"}`)}
            </div>
          </div>

          <label htmlFor="upload-input" className="upload-action">
            {t(`${routeName}.${"click_to_upload"}`)}
          </label>
          <div className="upload-note">
            {`(${t(`${routeName}.${"max_file_size"}`, { fileSize: 25 })})`}
          </div>
        </div>
      )}

      {fileUploadProgress > 1 && fileUploadProgress < 100 && (
        <div className="upload-status">
          <div className="upload-row-header">
            <div className="upload-header-title">
              {t(`${routeName}.${"upload_your_request"}`)}
            </div>
            <img
              src={ChevronUp}
              alt="upload-icon"
              className="upload-icon-small"
            />
          </div>
          <label className="description">
            {t(`${routeName}.${"boost_approval_rate"}`)}
          </label>
          <div className="upload-header">
            <div className="file-name-container">
              <img
                src={DocumentIcon}
                alt="upload-icon"
                className="upload-icon-small"
              />
              <div className="file-name-wrapper">
                <p className={`file-name ${isRTL ? "file-name-rtl" : ""}`}>
                  {fileUploadDetails?.name}
                </p>
              </div>
            </div>
          </div>
          <p className="file-size">{fileUploadDetails?.size}</p>
          <div className="upload-progress-container">
            <div className="progress-bar">
              <div
                className="progress-fill-percent"
                style={{ width: `${fileUploadProgress}%` }}
              />
            </div>
            <div
              className={`progress-percent ${
                isRTL ? "rtl-progress-percent " : ""
              }`}
            >
              {fileUploadProgress}%
            </div>
          </div>
        </div>
      )}

      {fileUploadProgress === 100 && (
        <div className="upload-status success">
          <div className="upload-row-header">
            <div className="upload-header-title">
              {t(`${routeName}.${"upload_your_request"}`)}
            </div>
            <img
              src={ChevronUp}
              alt="upload-icon"
              className="upload-icon-small"
            />
          </div>
          <label className="description">
            {t(`${routeName}.${"boost_approval_rate"}`)}
          </label>
          <div className="upload-header">
            <div className="file-name-container">
              <img
                src={DocumentIcon}
                alt="upload-icon"
                className="upload-icon-small"
              />
              <div className="file-name-wrapper">
                <p className={`file-name ${isRTL ? "file-name-rtl" : ""}`}>
                  {fileUploadDetails?.name}
                </p>
              </div>
            </div>
            <img
              src={Bin}
              alt="delete-icon"
              className="delete-icon"
              onClick={reset}
            />
          </div>
          <p className="file-size">{fileUploadDetails?.size}</p>
          <div className="upload-progress-container">
            <div className="progress-bar green">
              <div className="progress-fill" style={{ width: "100%" }} />
            </div>
            <span
              className={`progress-percent-complete ${
                isRTL ? "rtl-progress-percent-complete" : ""
              }`}
            >
              100%
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default UploadCard;
